/** @format */

import { memo } from 'react'

import styles from 'dir/styles/courses.module.css'

export const _3 = memo(() => (
  <section className={styles.section}>
    <h2 className={styles.h2}>1 - Вкладка Console в Chrome DevTools</h2>
    <p className={styles.description}>
      При написании кода всегда будут оповещения и ошибки, это нормально. Консоль показывает информацию, связанную с
      веб-страницей, в том числе сообщения об ошибках, предупреждениях исполнения JS-кода, запущенного в контексте
      страницы.
    </p>

    <p className={styles.description}>Чтобы открыть инструменты разработчика на вкладке Console:</p>
    <ul className={styles.list}>
      <li className={styles.list__item}>
        Windows и Linux - <code className={styles.code}>Ctrl+Shift+J</code> или <code className={styles.code}>F12</code>
      </li>
      <li className={styles.list__item}>
        MacOS - <code className={styles.code}>Command+Option+J</code>
      </li>
    </ul>
    <section className={styles.subsection}>
      <h2 className={styles.h2}>Дополнительные материалы</h2>
      <ul className={styles.list}>
        <li className={styles.list__item}>
          <a
            className={styles.link}
            href="https://www.geeksread.com/javascript-lesson-google-developer-tool-javascript/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Introduction to Google Chrome Developer tool for JavaScript
          </a>
        </li>
        <li className={styles.list__item}>
          <a
            className={styles.link}
            href="https://developers.google.com/web/tools/chrome-devtools/console/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Справка по Chrome DevTools от Google
          </a>
        </li>
        <li className={styles.list__item}>
          <a
            className={styles.link}
            href="https://medium.freecodecamp.org/how-you-can-improve-your-workflow-using-the-javascript-console-bdd7823a9472"
            target="_blank"
            rel="noopener noreferrer"
          >
            How you can improve your workflow using the JavaScript console
          </a>
        </li>
      </ul>
    </section>
  </section>
))
